import { Box } from '@mantine/core';
import dayjs from 'dayjs';
import { DailyEvents } from './Calendar.daily-events';
import { EventsByDay } from '../types';

export const dayRenderer: React.FC<{ date: string; events: EventsByDay }> = ({ date, events }) => {
  const day = dayjs(date).date();
  return (
    <>
      <Box ml="auto">{day}</Box>
      <DailyEvents date={date} events={events} />
    </>
  );
};
